import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './FieldFooter.scss'

import { SlideIn } from '../Transitions'

const FieldFooter = ({ errorMessage, description, disabled }) =>
	<div styleName={disabled ? 'footer-disabled' : 'footer'}>
		{errorMessage
			? <SlideIn from="left">
					<div styleName="error">
						<span>
							{errorMessage}
						</span>
					</div>
				</SlideIn>
			: null}
		<div styleName="description">
			{description}
		</div>
	</div>

FieldFooter.propTypes = {
	errorMessage: React.PropTypes.string
}

export default CSSModules(FieldFooter, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Form/FieldFooter.js